export default __webpack_public_path__ + "static/media/route.8ec7bca0.svg";